<template>
  <CModal :title="title"
          color="success"
          :show="show"
          :centered="true"
          @update:show="handleCancel">

    <div class="content">
      <h3 class="modal-title">{{ title }}</h3>

      <div v-if="errors.length" class="my-3">
        <CAlert v-for="(error, index) in errors" :key="`error-${index}`" color="danger" closeButton>
          {{ error }}
        </CAlert>
      </div>

      <CRow>
        <CCol col="12">
          <CForm @submit="handleConfirm">
            <CInput label="Name"
                    v-model="fields.name.value"
                    :description="`${zone.type} name`"
                    placeholder="Name"
                    horizontal />

            <CSelect label="Type"
                     :value.sync="fields.type.value"
                     :options="fields.type.items"
                     description="berth type"
                     placeholder="Please select type"
                     horizontal />

            <CInput label="Company"
                    v-model="fields.company.value"
                    description="company name"
                    placeholder="Company name"
                    horizontal />

            <CTextarea label="Notes"
                       v-model="fields.notes.value"
                       description="notes"
                       placeholder="Notes" />
          </CForm>
        </CCol>
      </CRow>

    </div>

    <template #footer>
      <CButton @click="handleCancel" :disabled="processing" color="secondary">
        Cancel
      </CButton>

      <CButton @click="handleConfirm" :disabled="processing" color="success">
        Save
      </CButton>
    </template>

  </CModal>
</template>

<script>
import moment from 'moment'
import startCase from 'lodash-es/startCase'

import { mapActions } from 'vuex'


export default {
  name: 'map-entity-create-modal',

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: 'Edit confirmation',
    },

    zone: {
      type: Object,
      default: () => ({}),
    },

    layer: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      processing: false,
      errors: [],

      fields: {
        name: {
          enabled: true,
          value: '',
        },
        type: {
          enabled: true,
          value: 'BERTH',
          items: [
            { value: 'BERTH', label: 'Berth' },
            { value: 'LOADING_ANCHORAGE', label: 'Loading anchorage' },
          ],
        },
        company: {
          enabled: true,
          value: '',
        },
        notes: {
          enabled: true,
          value: '',
        },
      },
    };
  },

  methods: {
    ...mapActions(
      'polygons', [
        'createBerth',
      ],
    ),

    handleCancel() {
      this.$emit('update:show', false);
      this.$emit('cancel', this.layer);
    },

    async handleConfirm(evt) {
      if(evt) {
        evt.preventDefault();
      }
      if(!this.isDataValid) {
        return;
      }

      this.processing = true;
      this.errors = [];

      let result = await this.createMethod({
        ...this.entityData,
      });

      if(result.error) {
        this.errors.push(result.error_details.message);
      } else {
        this.$emit('update:show', false);
        this.$emit('save');
      }

      this.processing = false;
    },

    setDefaultValues() {
      this.errors = [];

      Object.keys(this.fields).forEach(fieldName => {
        this.fields[fieldName].value = '';
      });
      this.fields.type.value = 'BERTH';
    },
  },

  computed: {
    isDataValid() {
      return (
        this.fields.name.value &&
        this.fields.name.value.length > 3
      );
    },

    createMethod() {
      return this[`create${startCase(this.zone.type)}`]
    },

    entityData() {
      return {
        portId: this.zone.portId,
        // berthId: 88888,
        berthName: this.fields.name.value,
        berthType: this.fields.type.value,
        company: this.fields.company.value,
        notes: this.fields.notes.value,
        geometryPolygon: JSON.stringify(this.zone.geoJSON.geometry),
      }
    },
  },

  watch: {
    show: function (value) {
      if(value) {
        this.fields.name.value = `${startCase(this.zone.type)} - ${moment.utc().format('YYYY-MM-DD HH:mm:ss')}`;
      } else {
        this.setDefaultValues();
      }
    },
  },
}
</script>

<style scoped>

</style>

<style scoped lang="scss">
  .modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
</style>
